exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".photo-preview{max-width:150px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-5418111d!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Product.vue
// module id = 888
// module chunks = 2